module.exports = __webpack_public_path__ + "img/T708.2596fb83.jpg";